import { useQuery } from '@apollo/client/react';

import { useAddDeposit } from 'src/context/deposit';
import { AssetTypeEnum } from 'src/graphql/schema';
import { AssetsDepositSourceDocument } from 'src/graphql/actions/asset/assetsDepositSource.query';
import { GetAssetsCountDocument } from 'src/graphql/actions/asset/getAssetsCount.query';
import { OauthReposConnDocument } from 'src/graphql/actions/repositories/oauthReposConn.query';

// eslint-disable-next-line react/display-name
export const withInitialOAuthData = (Component: React.ElementType) => () => {
  const {
    ui: { selectedEscrowId, integration },
  } = useAddDeposit();
  const { data: dataRepos, loading: loadingRepos } = useQuery(OauthReposConnDocument, {
    variables: {
      integrationId: integration?.id ?? '',
    },
    skip: !integration?.id,
  });
  const { data: assetsCountData, loading: assetsCountLoading } = useQuery(GetAssetsCountDocument, {
    fetchPolicy: 'network-only',
    variables: { softwareEscrowId: selectedEscrowId },
    skip: !selectedEscrowId,
  });
  const { data: assetsSourceData, loading: assetsSourceLoading } = useQuery(AssetsDepositSourceDocument, {
    fetchPolicy: 'network-only',
    variables: { softwareEscrowId: selectedEscrowId, perPage: assetsCountData?.assets?.nodesCount },
    skip: assetsCountLoading || !selectedEscrowId,
  });
  const isLoading = loadingRepos || assetsCountLoading || assetsSourceLoading;
  // Filter out the repositories that are already added to the escrow via the selected integration
  const assetsSource: {
    depositSource: string;
    integrationId: string;
    externalId: string | null;
  }[] = [];
  for (let i = 0; i < (assetsSourceData?.assetsSource?.nodes.length ?? 0); i++) {
    if (assetsSourceData?.assetsSource?.nodes[i].type !== AssetTypeEnum.OauthRepo) break;
    assetsSource.push({
      depositSource: assetsSourceData?.assetsSource?.nodes[i].depositSource ?? '',
      integrationId: assetsSourceData?.assetsSource?.nodes[i].integration?.id ?? '',
      externalId: assetsSourceData?.assetsSource?.nodes[i].externalId || null,
    });
  }
  const repositories =
    (!isLoading &&
      dataRepos?.oauthReposConn.repositories
        .filter(({ id, fullName }) => {
          return !assetsSource.some(
            ({ integrationId, depositSource, externalId }) =>
              integrationId === integration?.id && (externalId === id || fullName === depositSource),
          );
        })
        .map((repo) => ({ oauthRepositoryId: repo.id || '', oauthRepositoryFullName: repo.fullName ?? '' }))) ||
    [];

  return <Component repositories={repositories} isLoading={isLoading} />;
};
